import { BaseModel, Resource, Form, Entry, EntryTypes, TwoColumnLayout } from '@ngx-resource-toolkit/core';
import { anneeScolaireFetchOptions, periodeExamenFetchOptions, disciplineFetchOptions, professeurFetchOptions, cycleFetchOptions, niveauFetchOptions } from '../../resource/select-options';
import { environment } from '../../../../environments/environment';
import { LeaResource } from '../../resource/lea.resource';
import { FormGroup } from '@angular/forms';
import { BulletinReducer, BulletinEpics } from './bulletin.store';
import { jourOptions } from "../../resource/select-options-static";

@Resource({
    modes: {
        'default': {
            url: environment.proxyUrl + '/eleve',
            methods: LeaResource.methods
        }
    },
    store: {
        namespace: 'bulletin',
        reducer: BulletinReducer,
        epics: BulletinEpics,
    }
})
@Form({
    'search': {
        layout: TwoColumnLayout,
        onChanges: (value: BulletinSearchModel, form: FormGroup) => {
            const nom: string = form.value['nom'];
            if (nom) {
                form.patchValue({nom: nom.toUpperCase()},  {emitEvent: false});
            }
        }
    }
})
export class BulletinSearchModel extends BaseModel {
    @Entry({
        'search': {
            type: EntryTypes.RADIO,
            label: 'Type recherche',
            css: {
                label: 'col-xs-3',
                input: 'col-xs-4'
            },
            layout: 'left',
            options: [{
                value: 'E',
                label: 'Elèves'
            }, {
                value: 'B',
                label: 'Bulletins'
            },],
        }
    })
    typeRecherche: string = 'B';

    @Entry({
        'search': {
            type: EntryTypes.SELECT,
            label: 'Année',
            css: {
                group: 'col-xs-6',
                label: 'col-xs-3',
                input: 'col-xs-9'
            },
            layout: 'right',
            fetchOptions: anneeScolaireFetchOptions,
        }
    })
    anneeScolaire: number;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label : 'Période',
            fetchOptions: periodeExamenFetchOptions,
            css: {
                group: 'col-xs-6',
                label: 'col-xs-3',
                input: 'col-xs-9'
            },
            layout: 'right',
        },
        'search': {},
    })
    periode: number;

    @Entry({
        base: {
            label : 'Nom',
            type: EntryTypes.TEXT,
            css: {
                // group: 'col-xs-12',
                label: 'col-xs-2',
                input: 'col-xs-10'
            },
            layout: 'center',
        },
        'search': {},
    })
    nom: string;

    @Entry({
        'search': {
            type: EntryTypes.SELECT,
            label: 'Professeur',
            css: {
                label: 'col-xs-3',
                input: 'col-xs-9'
            },
            layout: 'left',
            // fetchOptions: professeurFetchOptions, doit être initialisé dynamiquement car en connexion professeur, il ne faut pas charger tous les professeurs
        },
    })
    idProfesseur: any; // ProfesseurModel;

    @Entry({
        'search': {
            type: EntryTypes.SELECT,
            label: 'Cycle',
            css: {
                label: 'col-xs-3',
                input: 'col-xs-9'
            },
            layout: 'right',
            fetchOptions: cycleFetchOptions,
        }
    })
    idCycle: string;

    @Entry({
        'search': {
            type: EntryTypes.SELECT,
            label: 'Niveau',
            css: {
                label: 'col-xs-3',
                input: 'col-xs-9'
            },
            layout: 'right',
            fetchOptions: niveauFetchOptions,
        }
    })
    idNiveau: string;

    @Entry({
        'search': {
            type: EntryTypes.SELECT,
            label: 'Discipline',
            css: {
                label: 'col-xs-3',
                input: 'col-xs-9'
            },
            layout: 'left',
            fetchOptions: disciplineFetchOptions,
        }
    })
    idDiscipline: any; // DisciplineModel;

    // 03/12/2021 : Ajout jour et cours
    @Entry({
        'search': {
            type: EntryTypes.SELECT,
            label: 'Jour',
            options: [{ label: 'Tous les jours', value: null }, ...jourOptions],
            css: {
                label: 'col-xs-3',
                input: 'col-xs-9'
            },
            layout: 'left',
        }
    })
    coursJourId: string;


    @Entry({
        'search': {
            type: EntryTypes.SELECT,
            label: 'Cours',
            css: {
                label: 'col-xs-3',
                input: 'col-xs-9'
            },
            layout: 'right',
            hidden: true,
        }
    })
    idCours: string;






    @Entry({
        'search': {
            type: EntryTypes.CHECKBOX,
            css: {
                group: 'col-xs-4',
            },
            options: [{
                value: 1,
                label: 'Validé'
            }],
            layout: 'left',
        }
    })
    isValide: number;

    @Entry({
        'search': {
            type: EntryTypes.CHECKBOX,
            css: {
                group: 'col-xs-4',
            },
            options: [{
                value: 2,
                label: 'Partiellement validé'
            }],
            layout: 'left',
        }
    })
    isPartiellementValide: number;

    @Entry({
        'search': {
            type: EntryTypes.CHECKBOX,
            css: {
                group: 'col-xs-4',
            },
            options: [{
                value: 4,
                label: 'Non validé'
            }],
            layout: 'left',
        }
    })
    isNonValide: number;

    @Entry({
        'search': {
            type: EntryTypes.CHECKBOX,
            css: {
                group: 'col-xs-12',
            },
            options: [{
                value: true,
                label: 'Non envoyé'
            }],
            layout: 'left',
        }
    })
    estNonEnvoye: boolean;
    /*
    typeRecherche : eleves ou bulletins
        si eleves : ServiceEleve.searchByCriteria(searchCriteria)
        si bulletins : ServiceEleve.searchElevesBulletin(searchCriteria)

    anneeScolaire

    nom
    idDiscipline
    idCycle
    idNiveau
    idProfesseur


    criteres specifiques à bulletins :
    bulletinsValides (1), partiellement validés (2), non validés (4)
    periode
    estNonEnvoye


     */

    constructor(data?) {
        super();
        Object.assign(this, data);
    }
}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/examen/models/bulletin-recherche.model.ts